<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      :width="width"
      :title="title"
      :close-on-click-modal="false"
    >
      <ChoiceTable ref="choiceTable" :height="height" :value="value" />
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ChoiceTable from './index.vue'
export default {
  components: { ChoiceTable },
  props: {
    value: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '1100px' },
    height: { type: Number, default: 500 },
  },
  data() {
    return {}
  },
  methods: {
    async confirm() {
      const packageData = await this.$refs.choiceTable.getPackageData()

      this.$emit('change', packageData)

      this.$emit('update:value', packageData)
      this.$emit('input', packageData)

      this.cancel()
    },
    cancel() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
